module.exports = __webpack_public_path__ + "img/rpdf.989f4de4.svg";